import { useEffect, useRef, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Container, TextContainer, InformationCircle } from './styled';
import { TextWidthOverflowPropsType } from './types';

const TextWithOverflow = ({
	children,
	maxLines = 5,
	tooltipColor = '#009EF7',
	style,
	withTooltip = false,
}: TextWidthOverflowPropsType) => {
	const textRef = useRef<HTMLDivElement | null>(null);
	const [showMore, setShowMore] = useState(false);

	useEffect(() => {
		if (!textRef.current) return;
		const handleShow = () => {
			const { scrollHeight, offsetHeight } = textRef.current!;

			setShowMore(scrollHeight > offsetHeight);
		};
		handleShow();
		window.addEventListener('resize', handleShow);
		return () => {
			window.removeEventListener('resize', handleShow);
			// setShowMore(false);
		};
	}, [textRef.current, children]);

	if (!children) return null;

	return (
		<Container>
			<TextContainer ref={textRef} maxLines={maxLines} style={style}>
				{children}
			</TextContainer>
			{showMore && withTooltip && (
				<OverlayTrigger
					placement="top"
					overlay={<Tooltip id={'tooltip-bottom'}>{children}</Tooltip>}
				>
					<div className="d-flex">
						<InformationCircle color={tooltipColor} />
					</div>
				</OverlayTrigger>
			)}
		</Container>
	);
};

export default TextWithOverflow;
